import { EditorState } from "@codemirror/state";

import { StatementGutterMarkerState } from "pages/DevelopWorkspace/Editor/Document/DocumentContent/DocumentEditor/extensions/statementGutter/statementGutterMarker";

export const getAiStateInitialSettings = (
  editorState: EditorState
): {
  pos: [number, number];
  sql: string;
  widgetPosition: number;
  wrappedText?: { before: string; after: string };
} => {
  const selection = editorState.selection.main;
  const hasManualSelection = selection.from !== selection.to;

  if (hasManualSelection) {
    const from = selection.from;
    const to = selection.to;
    const sql = editorState.doc.sliceString(from, to);
    // If selection lies strictly within a single detected statement, provide surrounding context
    const slice = editorState.field(StatementGutterMarkerState)?.slice;
    const wrappedText =
      slice &&
      slice.pos[0] <= from &&
      to <= slice.pos[1] &&
      !(slice.pos[0] === from && slice.pos[1] === to)
        ? {
            before: slice.text.slice(0, from - slice.pos[0]),
            after: slice.text.slice(to - slice.pos[0]),
          }
        : undefined;
    return {
      pos: [from, to],
      sql,
      widgetPosition: from,
      ...(wrappedText ? { wrappedText } : {}),
    };
  }

  const slice = editorState.field(StatementGutterMarkerState)?.slice;
  if (slice) {
    return {
      pos: slice.pos,
      sql: slice.text,
      widgetPosition: slice.pos[0],
    };
  }

  const head = editorState.selection.main.head;
  return {
    pos: [head, head],
    sql: "",
    widgetPosition: head,
  };
};
